import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/images/Genomii_logo.svg';

const Header = ({onSignUpClick}) => {
  const navigate = useNavigate();
  const handleSignUpClick = () => {
    // If we're already on the home page, just call the onSignUpClick function
    if (window.location.pathname === '/') {
      if (onSignUpClick) onSignUpClick();
    } else {
      // Navigate to home page
      navigate('/');
      
      // Then scroll to the email section after a short delay to allow the page to load
      setTimeout(() => {
        const emailSection = document.getElementById('email-signup');
        if (emailSection) {
          emailSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 300); // Adjust timing if needed
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/40 backdrop-blur-lg z-50 h-14 sm:h-16">
      <div className="container mx-auto px-4 lg:px-6 h-full flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img src={logo} alt="Logo" className="h-6 sm:h-7 w-auto" />
          </Link>
          
          {/* Sign Up Button */}
          <button 
            className="font-dm-sans bg-[#6DC5BD] text-white font-medium py-2 px-4 sm:py-3 sm:px-6 rounded-full transition-all hover:shadow-lg"
            onClick={handleSignUpClick}
          >
            Sign Up
          </button>
      </div>
    </header>
  );
};

export default Header;